<script lang="ts">
    import {createEventDispatcher} from 'svelte';
    const dispatch = createEventDispatcher();

    export let type: string = 'is-s';
    export let lineElement: Element = null;
    export let min: number = 1;
    export let max: number = 1;
    export let minBound: number = 1;
    export let maxBound: number = 1;
    export let lineWidth: number = 1;
    export let exp: number = 0;
    export let value = 0;
    let percent: number = 0;

    $: percent = (value - min) / (max - min) * 100;

    export let dragActive: boolean = false;

    document.addEventListener('mousemove', (e: MouseEvent) => {
        if(dragActive) {
            let percent = (e.pageX - lineElement.getBoundingClientRect().left) / lineWidth;
            let v = percent * (max - min) + min;
            v = Math.max(v, min);
            v = Math.min(v, max);
            v = Math.max(v, minBound);
            v = Math.min(v, maxBound);
            let mul = Math.pow(10, -exp);
            value = Math.round(v * mul) / mul;
            dispatch('change');
        }
    });
	document.addEventListener('mouseup', (e: MouseEvent) => dragActive = false);

    function handleDragStart() {
        dragActive = true;
    }
</script>

<div class="product-slider-widget--slider--knob {type}{dragActive ? ' active' : ''}" style="left: {percent}%" on:mousedown={handleDragStart}></div>

<style type="text/scss">
    $knob-diameter: 1em;

    .product-slider-widget--slider--knob {
		position: absolute;
		margin-left: -$knob-diameter / 2;
		margin-top: -$knob-diameter / 2;
		width: $knob-diameter;
		height: $knob-diameter;
        border-radius: 50%;

		user-select: none;
		-webkit-user-select: none;
		-moz-user-select: none;

		&.is-hidden {
			visibility: hidden;
			opacity: 0;
		}
	}
</style>
